export default __webpack_public_path__ + "static/media/500.68454164.svg";